import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "vant/lib/swipe/style";
import _Swipe from "vant/lib/swipe";
import "vant/lib/swipe-item/style";
import _SwipeItem from "vant/lib/swipe-item";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from "vue";
import App from "@/App.vue";
import store from "@/store/index";
import router from "@/router/router";
import "./utils/rem.js";
import { RouterTrasitionPlugin } from "@/plugins/routerTransition";
import { ImgSrcChangePlugin, ImageOnErrorPlugin } from "@/plugins/imgSrcChange";
import * as remoteImg from "@/plugins/remoteImg";
import BackTrack from "@/utils/backTrack";
import * as types from "@/store/constants/types";
import { i18n } from "@/i18n/i18n-setup";
import { RollbarPlugin } from "@/plugins/rollbar";
import FastClick from "@/plugins/fastclickPlugin";
import gestureBack from "@/plugins/gestureBack";
Vue.config.productionTip = false;
Vue.use(RouterTrasitionPlugin, router);
Vue.use(ImgSrcChangePlugin);
Vue.use(ImageOnErrorPlugin);
Vue.use(remoteImg.plugin);
Vue.use(_Swipe).use(_SwipeItem);
Vue.use(_Toast);
Vue.use(gestureBack);
document.body.addEventListener("touchstart", function () {}); //禁止选择

document.onselectstart = function () {
  return false;
}; //禁止复制


document.oncopy = function () {
  return false;
}; //rollbar:


var accessToken = "37d85d937e914f08ad45d02d789c544d"; //production下：

if (process.env.VUE_APP_SETTING_MODE === "production") {
  accessToken = "6abefe27611f4038bdd56f62bf4dc168";
}

if (process.env.NODE_ENV === "production") {
  Vue.use(RollbarPlugin, {
    accessToken: accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    source_map_enabled: true,
    environment: process.env.VUE_APP_VERSION,
    payload: {
      client: {
        javascript: {
          code_version: process.env.VUE_APP_VERSION
        }
      }
    }
  });
}

console.log("main.js加载完毕:", new Date().valueOf());
document.addEventListener("deviceready", onDeviceReady, false);

function initVue() {
  new Vue({
    i18n: i18n,
    router: router,
    store: store,
    render: function render(h) {
      return h(App);
    },
    created: function created() {
      store.dispatch(types.INITIAL_SETTING);
      console.log("Vue created:", new Date().valueOf());
      setTimeout(function () {
        console.log("navigator.splashscreen.hide：", new Date().valueOf());
        navigator.splashscreen.hide();
      }, 100);
    },
    mounted: function mounted() {
      console.log("Vue mounted:", new Date().valueOf()); // navigator.splashscreen.hide();
    }
  }).$mount("#app");
}

function onDeviceReady() {
  return _onDeviceReady.apply(this, arguments);
}

function _onDeviceReady() {
  _onDeviceReady = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            //检查更新方式
            console.log("onDeviceReady完毕:", new Date().valueOf()); //初始化vue

            initVue(); //安卓返回键的监听

            BackTrack.initial(); //关闭离线模式

            if (window.hostedwebapp && window.hostedwebapp.disableOfflinePage) {
              window.hostedwebapp.disableOfflinePage();
            } //FastClick:


            FastClick.attach(document.body); // document.addEventListener("offline", () => {
            //   Toast('no net work')
            // }, false);
            // document.addEventListener("online", () => {
            //   Toast('net work connect')
            // }, false);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _onDeviceReady.apply(this, arguments);
}